(() => {
  if (customElements.get('os-set-notices')) return;
  customElements.define('os-set-notices',class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready=true;
      this.dialog=this.querySelector('dialog');
      this.storageKey='ovrze:set-notice:'+this.dataset.setId;
      if (!this.dialog) return;
      this.querySelectorAll('[data-set-close]').forEach(button=>button.addEventListener('click',()=>this.dialog.close()));
      this.querySelector('[data-set-preview]')?.addEventListener('click',()=>this.open(false));
      this.dialog.addEventListener('close',()=>this.opener?.isConnected&&this.opener.focus({preventScroll:true}));
      this.dialog.addEventListener('click',event=>{
        if (event.target!==this.dialog) return;
        const box=this.dialog.getBoundingClientRect();
        if (event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom) this.dialog.close();
      });
      if (this.dataset.designMode==='true'||this.seen()) return;
      this.timer=setTimeout(()=>this.tryOpen(),Number(this.dataset.delay||8)*1000);
    }
    disconnectedCallback() {clearTimeout(this.timer);}
    seen() {
      try {return sessionStorage.getItem(this.storageKey)==='1';}
      catch {return true;}
    }
    blocked() {
      const cookie=document.querySelector('#shopify-pc__banner');
      const cookieVisible=cookie&&!cookie.hidden&&cookie.getBoundingClientRect().height>0&&getComputedStyle(cookie).display!=='none';
      const choosing=document.activeElement?.closest('form');
      return document.hidden||document.querySelector('dialog[open]')||cookieVisible||choosing;
    }
    tryOpen() {
      if (!this.isConnected||this.seen()) return;
      if (document.querySelector('.ow-drawer-item[data-item-product-id="'+this.dataset.setId+'"]')) return;
      if (this.blocked()) {this.timer=setTimeout(()=>this.tryOpen(),2000);return;}
      this.open(true);
    }
    open(remember) {
      if (this.dialog.open) return;
      this.opener=document.activeElement;
      this.dialog.showModal();
      if (remember) {try {sessionStorage.setItem(this.storageKey,'1');}catch {}}
    }
  });
})();
